export default "__VITE_ASSET__807b1905__"